import React from 'react';
import './divider.css'; // Make sure to create this CSS file

const Divider = () => {
  return <hr className="menu-divider" />;
};

export default Divider;
